import * as Sentry from '@sentry/react'

/**
 * Sentry DSN of the `bonidriver-portal` project. Not a secret — it is shipped in
 * the bundle by design; write access needs the auth token used for the sourcemap
 * upload in CI. Empty means "not configured yet" → initSentry() does nothing.
 */
const SENTRY_DSN = 'https://8e66d2dd78e66c35eb4af9c63fe01631@o4510035461472256.ingest.de.sentry.io/4511891380568144'

/**
 * Initialize Sentry error/performance reporting. Called once from main.tsx.
 *
 * Production builds only — in dev the browser console is the better channel and
 * we do not want local noise in the Sentry project.
 */
export function initSentry() {
  if (!import.meta.env.PROD || !SENTRY_DSN) return

  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
    tracesSampleRate: 1.0,
    // Attach tracing headers only to our own API, so third parties never see them.
    tracePropagationTargets: [/^https:\/\/api\.(staging\.)?bonisoft\.de\/api/],
  })
}
